import React, { createContext, useContext, useEffect, useState } from "react";
import { customerApi, formatApiErrorDetail } from "../lib/api";

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null); // null = checking, false = not auth, obj = auth
  const [loading, setLoading] = useState(true);

  const fetchMe = () => customerApi.get("/customer/me").then(({ data }) => setCustomer(data));

  useEffect(() => {
    const token = localStorage.getItem("ms_customer_token");
    if (!token) {
      setCustomer(false);
      setLoading(false);
      return;
    }
    fetchMe()
      .catch(() => {
        localStorage.removeItem("ms_customer_token");
        setCustomer(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await customerApi.post("/auth/login", { email, password });
      localStorage.setItem("ms_customer_token", data.token);
      await fetchMe();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const register = async (payload) => {
    try {
      const { data } = await customerApi.post("/auth/register", payload);
      localStorage.setItem("ms_customer_token", data.token);
      await fetchMe();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    localStorage.removeItem("ms_customer_token");
    setCustomer(false);
  };

  return (
    <CustomerAuthContext.Provider value={{ customer, loading, login, register, logout, refresh: fetchMe }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
